import CharacterSubmissionItem from "./CharacterSubmissionItem";

export default CharacterSubmissionItem;
